import { render, staticRenderFns } from "./CatalogForm.vue?vue&type=template&id=60b4d409"
import script from "./CatalogForm.vue?vue&type=script&lang=js"
export * from "./CatalogForm.vue?vue&type=script&lang=js"
import style0 from "./CatalogForm.vue?vue&type=style&index=0&id=60b4d409&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports